import React, { useState } from 'react';
import { Mail, Plus, X } from 'lucide-react';
import Button from '../../../../components/common/Button';
import Alert from '../../../../components/common/Alert';

export default function TeamInvites({ onComplete, initialData = [], companyDomain }) {
  const [invites, setInvites] = useState(initialData);
  const [newEmail, setNewEmail] = useState('');

  const handleAddInvite = () => {
    if (newEmail && newEmail.endsWith(`@${companyDomain}`)) {
      setInvites([...invites, { email: newEmail }]);
      setNewEmail('');
    }
  };

  const handleRemoveInvite = (email) => {
    setInvites(invites.filter(invite => invite.email !== email));
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-navy mb-1">
          Invite Team Members
        </label>
        <div className="flex gap-2">
          <div className="relative flex-1">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 w-5 h-5" />
            <input
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-lg border-2 border-light-purple focus:border-primary focus:ring focus:ring-primary/20 transition-colors"
              placeholder={`user@${companyDomain}`}
            />
          </div>
          <Button onClick={handleAddInvite} disabled={!newEmail.endsWith(`@${companyDomain}`)}>
            <Plus className="w-4 h-4" />
            Add
          </Button>
        </div>
      </div>

      {invites.length > 0 && (
        <div className="space-y-2">
          {invites.map((invite) => (
            <div
              key={invite.email}
              className="flex items-center justify-between p-3 bg-light-purple/10 rounded-lg"
            >
              <span className="text-navy">{invite.email}</span>
              <button
                onClick={() => handleRemoveInvite(invite.email)}
                className="text-navy/60 hover:text-error transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}

      <Alert type="info">
        Team members will receive an email invitation to join your Stickr workspace.
      </Alert>

      <div className="flex justify-end gap-3">
        <Button variant="outline" onClick={() => window.history.back()}>
          Back
        </Button>
        <Button onClick={() => onComplete(invites)}>
          Complete Setup
        </Button>
      </div>
    </div>
  );
}